import React from 'react';
import Card from '@material-ui/core/Card';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import Fade from '@material-ui/core/Fade';
import Icons from 'consts/icons';
import { userProfileStyles } from 'consts/styles/UserProfile';
import { formStyles } from 'consts/styles/Form';

const ShowUsers = props => {
  const { users, organizations, iconEditActionFunction, language } = props;

  const strings = language.adminZone.userList;
  const userProfileClasses = userProfileStyles();
  const returnProperOrganizationForUser = (userOrganization, index) =>
    organizations.find(organization => organization.uid === userOrganization)
      ?.name;

  const formClasses = formStyles();

  return (
    <Fade in={users.length > 0} timeout={1000}>
      <Grid container className={`${formClasses.Form}__overflow-component`}>
        {users.map((user, index) => (
          <Grid
            className={`${userProfileClasses.userProfile}--border-radius`}
            key={index}
            container
            item
            xs={4}
          >
            <Card
              className={`${userProfileClasses.userProfile}__card ${
                !user.isActive_
                  ? `${userProfileClasses.userProfile}__card--inactive`
                  : ''
              }`}
            >
              <div
                className={`${userProfileClasses.userProfile}__card__header`}
              >
                <img
                  className={`${userProfileClasses.userProfile}__card__user__image__header`}
                  src="/logoHawke/loginImage.png"
                  alt="hawkelogo"
                />
              </div>
              <div>
                <div
                  className={`${userProfileClasses.userProfile}__card__body`}
                >
                  <img
                    className={`${userProfileClasses.userProfile}__card__user__image`}
                    alt="user_photo"
                    src={
                      user.avatar ? user.avatar : '/logoHawke/user-profile.png'
                    }
                  />
                  <span
                    className={`${userProfileClasses.userProfile}__card__user ${
                      user.isActive_
                        ? `${userProfileClasses.userProfile}__card__user--active`
                        : `${userProfileClasses.userProfile}__card__user--inactive`
                    }`}
                  >{`${user.firstName} ${user.lastName}`}</span>
                  <div
                    className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between ${userProfileClasses.userProfile}__card__user__details`}
                  >
                    <div
                      className={`${userProfileClasses.userProfile}__card__user__details__title`}
                    >
                      {strings.user_}:
                    </div>
                    <div
                      className={`${userProfileClasses.userProfile}__card__user__details--strong ${userProfileClasses.userProfile}__card__user__details__value`}
                    >
                      {user.username}
                    </div>
                  </div>
                  <div style={{ width: '100%' }}>
                    <div
                      className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between ${userProfileClasses.userProfile}__card__user__details`}
                    >
                      <div
                        className={`${userProfileClasses.userProfile}__card__user__details__title`}
                      >
                        {strings.address_}:
                      </div>
                      <div
                        className={`${userProfileClasses.userProfile}__card__user__details__value`}
                      >
                        {`${user.address?.city} ${user.address?.street} ${user.address?.number}`}
                      </div>
                    </div>
                    <div
                      className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between ${userProfileClasses.userProfile}__card__user__details`}
                    >
                      <div
                        className={`${userProfileClasses.userProfile}__card__user__details__title`}
                      >
                        {strings.phoneNumber_}:
                      </div>
                      <div
                        className={`${userProfileClasses.userProfile}__card__user__details__value`}
                      >
                        {user.phone}
                      </div>
                    </div>
                    <div
                      className={`${userProfileClasses.userProfile}__card__user__details`}
                    >
                      <div
                        className={`${userProfileClasses.userProfile}__card__user__details__title`}
                      >
                        {strings.mail_}:
                      </div>
                      <div
                        className={`${userProfileClasses.userProfile}__card__user__details__value`}
                      >
                        {user.email}
                      </div>
                    </div>
                    <div
                      className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between ${userProfileClasses.userProfile}__card__user__details`}
                    >
                      <div
                        className={`${userProfileClasses.userProfile}__card__user__details__title`}
                      >
                        {strings.organization_}:
                      </div>
                      <div
                        className={`${userProfileClasses.userProfile}__card__user__details__value`}
                      >
                        {returnProperOrganizationForUser(
                          user.organization,
                          index
                        )
                          ? returnProperOrganizationForUser(
                              user.organization,
                              index
                            )
                          : strings.organizationData_}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`${formClasses.Form}--bottom-of-container`}>
                <hr
                  className={`${userProfileClasses.userProfile}__card__divider`}
                />
                <Grid
                  className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between`}
                  container
                >
                  <Grid
                    className={`${userProfileClasses.userProfile}__card__footer ${formClasses.Form}--flex ${formClasses.Form}--flex--center ${formClasses.Form}--flex--direction`}
                    item
                    xs={4}
                    role="button"
                    tabIndex={0}
                    onKeyDown={() => iconEditActionFunction(user)}
                    onClick={() => iconEditActionFunction(user)}
                  >
                    <span
                      className={`${userProfileClasses.userProfile}__card__footer__icon`}
                    >
                      <Icons.Actions.Preview />
                    </span>
                    <span
                      className={`${userProfileClasses.userProfile}__card__footer__title`}
                    >
                      {strings.preview_}
                    </span>
                  </Grid>
                  <Grid item xs={4}></Grid>
                  <Grid
                    className={`${userProfileClasses.userProfile}__card__footer ${formClasses.Form}--flex ${formClasses.Form}--flex--center ${formClasses.Form}--flex--direction`}
                    item
                    xs={4}
                  >
                    <span
                      className={`${userProfileClasses.userProfile}__card__footer__icon`}
                    >
                      {user.isActive_ ? (
                        <Icons.Actions.CheckCircle
                          className={`${userProfileClasses.userProfile}__card__footer__icon--active`}
                        />
                      ) : (
                        <Icons.Actions.RemoveCircle
                          className={`${userProfileClasses.userProfile}__card__footer__icon--inactive`}
                        />
                      )}
                    </span>
                    <span
                      className={`${userProfileClasses.userProfile}__card__footer__title`}
                    >
                      {user.isActive_ ? strings.active_ : strings.inactive_}
                    </span>
                  </Grid>
                </Grid>
              </div>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Fade>
  );
};

ShowUsers.propTypes = {
  users: PropTypes.array.isRequired,
  organizations: PropTypes.array.isRequired,
  iconEditActionFunction: PropTypes.func.isRequired,
  language: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  language: state.language,
});

export default connect(mapStateToProps)(ShowUsers);
